export enum AnalyticsEvents {
  OpenRequestClicked = 'Open Request Opened',
  OpenRequestAccessUnitsClicked = 'Open Request Units Displayed',
  OpenRequestAccessDetailsClicked = 'Open Request Details Displayed',
  ClosedRequestClicked = 'Closed Request Opened',
  ClosedRequestAccessUnitsClicked = 'Closed Request Units Displayed',
  RequestAgainClicked = 'Request Again Initiated',
  TaskApproveClicked = 'Task Approval Initiated',
  TaskRejectClicked = 'Task Rejection Initiated',
  TaskClicked = 'Task Opened',
  TaskAccessUnitsClicked = 'Task Units Displayed',
  AccessRequestSendClicked = 'Access Request Send Initiated',
  AccessRequestSent = 'Access Request Successfully Sent',
  AccessRequestFailed = 'Access Request Sending Failed',
  BundleRequestSendClicked = 'Bundle Request Send Initiated',
  BundleRequestSent = 'Bundle Request Successfully Sent',
  BundleRequestFailed = 'Bundle Request Sending Failed',
  TemplateSaveClicked = 'Template Save Initiated',
  MyAccessInitiated = 'My Access Initiated in Sidebar',
  MyRequestsInitiated = 'My Requests Initiated in Sidebar',
  MyTasksInitiated = 'My Tasks Initiated in Sidebar',
  SessionGroupToggled = 'Session Group Toggled',
  SessionInstructionsInitiated = 'Session Instructions Initiated',
  SessionCliInitiated = 'Session CLI Initiated',
  SessionParametersInitiated = 'Session Parameters Initiated',
  SessionLinkInitiated = 'Session Link Initiated',
  LinkToConsoleInitiated = 'Link to Console Initiated',
  UseAccessInitiated = 'Use Access Initiated',
  CopyButtonInitiated = 'Copy Button Initiated',
  ConnectSessionsClicked = 'Connect Sessions Clicked',
  AddSessionClicked = 'Add Sessions Clicked',
  UseAccessClicked = 'Use Access Clicked',
  CheckRequestDetailsClicked = 'Check Request Details Clicked',
  ResourcesRequestSendClicked = 'Resources Request Send Initiated',
  ResourcesRequestFailed = 'Resources Request Sending Failed',
  ResourcesRequestSent = 'Resources Request Successfully Sent',
  ResetCredentialsClicked = 'Reset Credentials Clicked',
  AccessDetailsTabClicked = 'Access Details Tab Clicked',
  NewRequestButtonClicked = 'New Request Button Clicked',
  AccessDetailsLaunchButtonClicked = 'Access Details Launch Button Clicked',
  ProvideReasonJustificationCancelButtonClicked = 'Provide Reason Justification Cancel Button Clicked',
}
